import { useTranslation } from 'react-i18next';
import Icon from '#app/assets/favicons/android-chrome-192x192.png';
import Illustration from '#app/assets/images/glow-bottom.svg';
import Particles from './particles';

export default function Hero() {
	const { t } = useTranslation();

	return (
		<section>
			<div className="relative mx-auto max-w-6xl px-4 sm:px-6">
				{/* Particles animation */}
				<Particles className="absolute inset-0 -z-10" />

				{/* Illustration */}
				<div
					className="pointer-events-none absolute inset-0 -z-10 -mx-28 overflow-hidden rounded-b-[3rem]"
					aria-hidden="true"
				>
					<div className="absolute bottom-0 left-1/2 -z-10 -translate-x-1/2">
						<img
							src={Illustration}
							className="max-w-none"
							width={2146}
							alt="Hero Illustration"
						/>
					</div>
				</div>

				<div className="pb-16 pt-32 md:pb-32 md:pt-52">
					{/* Hero content */}
					<div className="mx-auto max-w-3xl text-center">
						<div className="mb-6" data-aos="fade-down">
							<div className="relative inline-flex h-6 before:absolute before:inset-0 before:bg-teal-500 before:blur-md"></div>
						</div>

						<div
							className="mx-auto inline-flex max-w-xs justify-center space-x-4 space-y-0"
							data-aos="fade-down"
							data-aos-delay="100"
						>
							<img
								className="mb-8 rounded-3xl bg-gradient-to-b from-slate-300/20 to-transparent p-px opacity-90 drop-shadow-lg"
								src={Icon}
								width={100}
								height={100}
							/>
						</div>

						<h1
							className="h1 bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 bg-clip-text pb-4 text-transparent"
							data-aos="fade-down"
						>
							ExploraLIS
						</h1>
						<p
							className="mb-8 text-lg text-slate-300"
							data-aos="fade-down"
							data-aos-delay="200"
						>
							{t('hero.subtitle')}
						</p>
						<div
							className="mx-auto max-w-xs space-y-4 sm:inline-flex sm:max-w-none sm:justify-center sm:space-x-4 sm:space-y-0"
							data-aos="fade-down"
							data-aos-delay="400"
						>
							<div>
								<a
									className="btn group w-full bg-gradient-to-r from-white/80 via-white to-white/80 text-slate-900 transition duration-150 ease-in-out hover:bg-white"
									href="contact"
								>
									{t('button.contact-us')}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
